var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeDeadline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.036,
    height: 31,
    viewBox: "0 0 23.036 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "burning",
    transform: "translate(-8.957 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52857",
    "data-name": "Path 52857",
    d: "M23.993,4.5s1.5,4-1,5C20.883,6.758,22.3,1,15.493,1a8.583,8.583,0,0,1,.753,9.317,4.567,4.567,0,0,1-1.523-3.1A15.83,15.83,0,0,0,8.993,20.5a11.5,11.5,0,0,0,23,0,19.712,19.712,0,0,0-8-16Z",
    transform: "translate(0)",
    fill: "#ff786e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52858",
    "data-name": "Path 52858",
    d: "M22.745,32.1a11.5,11.5,0,0,0,10.75-11.473A19.814,19.814,0,0,0,27.373,6.187c.008.057.015.115.022.173a2.924,2.924,0,0,1-2.9,3.269c-1.926-2.5-.915-7.515-5.9-8.372a8.641,8.641,0,0,1,1.322,7.622,2.271,2.271,0,0,1-2.168,1.566A5.3,5.3,0,0,1,16.46,8.491a15.935,15.935,0,0,0-4.465,12.138A11.5,11.5,0,0,0,22.742,32.1Z",
    transform: "translate(-1.502 -0.128)",
    fill: "#ff5050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52859",
    "data-name": "Path 52859",
    d: "M14.524,5.075a2.293,2.293,0,0,1-2-2.5,3.117,3.117,0,0,1,.034-.425,2.447,2.447,0,0,0-1.534,2.425,2.293,2.293,0,0,0,2,2.5A2.191,2.191,0,0,0,14.99,5,1.62,1.62,0,0,1,14.524,5.075Z",
    transform: "translate(-1.031 -0.575)",
    fill: "#ff786e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52860",
    "data-name": "Path 52860",
    d: "M13.551,3.654a2.832,2.832,0,0,0-.527,1.673,2.459,2.459,0,0,0,1.5,2.412,2.355,2.355,0,0,0,1.466-1.987,1.619,1.619,0,0,1-.466.075A2.212,2.212,0,0,1,13.551,3.654Z",
    transform: "translate(-2.032 -1.327)",
    fill: "#ff5050"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2657",
    "data-name": "Ellipse 2657",
    cx: 7,
    cy: 7,
    r: 7,
    transform: "translate(13.479 13.5)",
    fill: "#e6f0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52861",
    "data-name": "Path 52861",
    d: "M27,28a7,7,0,0,0-5.424,11.423,7,7,0,0,0,9.85-9.846A6.969,6.969,0,0,0,27,28Z",
    transform: "translate(-5.523 -13.5)",
    fill: "#f5faff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_45575",
    "data-name": "Group 45575",
    transform: "translate(12.979 13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52862",
    "data-name": "Path 52862",
    d: "M32,35H31V31.5a.5.5,0,0,1,1,0Z",
    transform: "translate(-24 -28)",
    fill: "#3f4d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52863",
    "data-name": "Path 52863",
    d: "M36,40.027H33v-1h3a.5.5,0,1,1,0,1Z",
    transform: "translate(-25 -32.013)",
    fill: "#3f4d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52864",
    "data-name": "Path 52864",
    d: "M31.5,27a.5.5,0,0,1-.5-.5V25h1v1.5A.5.5,0,0,1,31.5,27Z",
    transform: "translate(-24 -25)",
    fill: "#3f4d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52865",
    "data-name": "Path 52865",
    d: "M32,53H31V51.5a.5.5,0,1,1,1,0Z",
    transform: "translate(-24 -38)",
    fill: "#3f4d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52866",
    "data-name": "Path 52866",
    d: "M24.384,28.308l-.75-1.3.866-.5.75,1.3a.5.5,0,0,1-.866.5Z",
    transform: "translate(-20.317 -25.754)",
    fill: "#3f4d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52867",
    "data-name": "Path 52867",
    d: "M37.817,51.44l-.75-1.3a.5.5,0,0,1,.866-.5l.75,1.3Z",
    transform: "translate(-27 -37.195)",
    fill: "#3f4d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52868",
    "data-name": "Path 52868",
    d: "M19.808,33.25l-1.3-.75.5-.866,1.3.75a.5.5,0,0,1-.5.866Z",
    transform: "translate(-17.754 -28.317)",
    fill: "#3f4d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52869",
    "data-name": "Path 52869",
    d: "M42.941,46.683l-1.3-.75a.5.5,0,1,1,.5-.866l1.3.75Z",
    transform: "translate(-29.195 -35)",
    fill: "#3f4d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52870",
    "data-name": "Path 52870",
    d: "M18.5,40H17V39h1.5a.5.5,0,0,1,0,1Z",
    transform: "translate(-17 -32)",
    fill: "#3f4d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52871",
    "data-name": "Path 52871",
    d: "M45,40H43.5a.5.5,0,0,1,0-1H45Z",
    transform: "translate(-30 -32)",
    fill: "#3f4d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52872",
    "data-name": "Path 52872",
    d: "M19.009,46.683l-.5-.866,1.3-.75a.5.5,0,1,1,.5.866Z",
    transform: "translate(-17.755 -35)",
    fill: "#3f4d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52873",
    "data-name": "Path 52873",
    d: "M41.459,33.067a.5.5,0,0,1,.183-.683l1.3-.75.5.866-1.3.75A.5.5,0,0,1,41.459,33.067Z",
    transform: "translate(-29.196 -28.317)",
    fill: "#3f4d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52874",
    "data-name": "Path 52874",
    d: "M24.5,51.44l-.866-.5.75-1.3a.5.5,0,0,1,.866.5Z",
    transform: "translate(-20.317 -37.195)",
    fill: "#3f4d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52875",
    "data-name": "Path 52875",
    d: "M37.25,28.491a.5.5,0,0,1-.183-.683l.75-1.3.866.5-.75,1.3a.5.5,0,0,1-.683.183Z",
    transform: "translate(-27 -25.754)",
    fill: "#3f4d56"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_52876",
    "data-name": "Path 52876",
    d: "M23,22a9,9,0,1,0,9,9A9,9,0,0,0,23,22Zm0,16a7,7,0,1,1,7-7A7,7,0,0,1,23,38Z",
    transform: "translate(-2.521 -10.5)",
    fill: "#ffd246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52877",
    "data-name": "Path 52877",
    d: "M25,24a8.994,8.994,0,0,0-6.841,14.839A8.993,8.993,0,0,0,30.841,26.161,8.957,8.957,0,0,0,25,24ZM24,39a7,7,0,1,1,7-7A7,7,0,0,1,24,39Z",
    transform: "translate(-3.521 -11.5)",
    fill: "#ffbe37"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2658",
    "data-name": "Ellipse 2658",
    cx: 1.25,
    cy: 1.25,
    r: 1.25,
    transform: "translate(19.229 19.25)",
    fill: "#5a6978"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeDeadline);
export default __webpack_public_path__ + "static/media/home-deadline.1d48e124ca0e3dd82ac64acbdd223f64.svg";
export { ForwardRef as ReactComponent };